import _styled from "@emotion/styled-base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import PropTypes from 'prop-types';
import React from 'react';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AccordionItemStyles = _styled("div", {
  target: "eubprqm0"
})(process.env.NODE_ENV === "production" ? {
  name: "1xpp3v1",
  styles: "cursor:pointer;display:flex;flex-direction:column;"
} : {
  name: "1xpp3v1",
  styles: "cursor:pointer;display:flex;flex-direction:column;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0FjY29yZGlvbi9BY2NvcmRpb25JdGVtLmpzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFJc0MiLCJmaWxlIjoiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvQWNjb3JkaW9uL0FjY29yZGlvbkl0ZW0uanN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJ1xuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnXG5cbmNvbnN0IEFjY29yZGlvbkl0ZW1TdHlsZXMgPSBzdHlsZWQuZGl2YFxuICBjdXJzb3I6IHBvaW50ZXI7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG5gXG5cbmNvbnN0IEFjY29yZGlvbkl0ZW0gPSAoe1xuICBjaGlsZHJlbixcbiAgZGF0YVRlc3RJZCxcbiAgaWNvbkRpcmVjdGlvbixcbiAgaXNPcGVuLFxuICBvbkhlYWRlckNsaWNrLFxuICByZW5kZXJIZWFkZXIsXG4gIHNtYWxsLFxufSkgPT4gKFxuICA8PlxuICAgIDxBY2NvcmRpb25JdGVtU3R5bGVzXG4gICAgICBkYXRhLXRlc3QtaWQ9e2RhdGFUZXN0SWR9XG4gICAgICBvbkNsaWNrPXtvbkhlYWRlckNsaWNrfVxuICAgICAgc21hbGw9e3NtYWxsfVxuICAgICAgaWNvbkRpcmVjdGlvbj17aWNvbkRpcmVjdGlvbn1cbiAgICA+XG4gICAgICB7cmVuZGVySGVhZGVyKCl9XG4gICAgPC9BY2NvcmRpb25JdGVtU3R5bGVzPlxuXG4gICAge2lzT3BlbiAmJiBjaGlsZHJlbn1cbiAgPC8+XG4pXG5cbkFjY29yZGlvbkl0ZW0ucHJvcFR5cGVzID0ge1xuICBjaGlsZHJlbjogUHJvcFR5cGVzLm5vZGUuaXNSZXF1aXJlZCxcbiAgZGF0YVRlc3RJZDogUHJvcFR5cGVzLnN0cmluZyxcbiAgaWNvbkRpcmVjdGlvbjogUHJvcFR5cGVzLm9uZU9mKFsnbGVmdCcsICdyaWdodCddKSxcbiAgaXNPcGVuOiBQcm9wVHlwZXMuYm9vbCxcbiAgb25IZWFkZXJDbGljazogUHJvcFR5cGVzLmZ1bmMsXG4gIHJlbmRlckhlYWRlcjogUHJvcFR5cGVzLmZ1bmMuaXNSZXF1aXJlZCxcbiAgc21hbGw6IFByb3BUeXBlcy5ib29sLFxufVxuXG5leHBvcnQgZGVmYXVsdCBBY2NvcmRpb25JdGVtXG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var AccordionItem = function AccordionItem(_ref) {
  var children = _ref.children,
    dataTestId = _ref.dataTestId,
    iconDirection = _ref.iconDirection,
    isOpen = _ref.isOpen,
    onHeaderClick = _ref.onHeaderClick,
    renderHeader = _ref.renderHeader,
    small = _ref.small;
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(AccordionItemStyles, {
    "data-test-id": dataTestId,
    onClick: onHeaderClick,
    small: small,
    iconDirection: iconDirection
  }, renderHeader()), isOpen && children);
};
AccordionItem.propTypes = {
  children: PropTypes.node.isRequired,
  dataTestId: PropTypes.string,
  iconDirection: PropTypes.oneOf(['left', 'right']),
  isOpen: PropTypes.bool,
  onHeaderClick: PropTypes.func,
  renderHeader: PropTypes.func.isRequired,
  small: PropTypes.bool
};
export default AccordionItem;